import React, { FC }                from 'react';
import { Theme, Container, Box }    from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { ILinkButtonData }          from '@typings/components';
import { LinkButton }               from '@components/LinkButton/LinkButton';

interface IStyledProps {
  isWhite?: boolean;
}

const useStyles = makeStyles<Theme, IStyledProps>(({ palette, spacing }) => createStyles({
  page         : ({ isWhite }) => ({ backgroundColor: isWhite ? palette.common.white : 'transparent' }),
  container    : { paddingBlock: `${spacing(3)}px ${spacing(8)}px` },
  linksWrapper : {
    display      : 'flex',
    marginBottom : spacing(2),
  },
}));

interface IProps extends IStyledProps {
  navLinksData: ILinkButtonData[];
}

export const PageWrapper: FC<IProps> = ({
  isWhite,
  navLinksData,
  children,
}) => {
  const { page, container, linksWrapper } = useStyles({ isWhite });

  return (
    <Box className={page}>
      <Container classes={{ root: container }}>
        <Box className={linksWrapper}>
          {navLinksData.map((linkData) => (
            <LinkButton
              key = {linkData.label}
              {...linkData}
            />
          ))}
        </Box>

        {children}
      </Container>
    </Box>
  );
};
